import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const ListContext = getContext(Symbols.ListContext, { getPrefixCls });
const BaseListContextProvider = function ListContextProvider(props) {
    const { children, grid, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        grid,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, grid]);
    return (React.createElement(ListContext.Provider, { value: value }, children));
};
BaseListContextProvider.displayName = 'ListContextProvider';
export const ListContextProvider = memo(BaseListContextProvider);
export default ListContext;
